import {
  externalPaymentLinkSummarySchema,
  type ExternalPaymentLinkSummary,
} from '@billing/validation';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { getRequest } from 'api/utils/HttpMethods';

const claimExternalPaymentsPath = '/resource/claim/external-payments';

export const claimExternalPaymentQueryKeys = {
  all: ['claimExternalPayments'],
  byClaim: (claimID: string) => [
    ...claimExternalPaymentQueryKeys.all,
    'claim',
    claimID,
  ],
};

const getClaimExternalPaymentLinks = async (
  claimID: string
): Promise<ExternalPaymentLinkSummary[]> => {
  const params = new URLSearchParams({ claimID });
  const response = await getRequest<unknown>(
    '',
    `${claimExternalPaymentsPath}?${params.toString()}`
  );
  return externalPaymentLinkSummarySchema.array().parse(response);
};

export const useClaimExternalPaymentLinks = (
  claimID: string
): UseQueryResult<ExternalPaymentLinkSummary[], Error> =>
  useQuery({
    queryKey: claimExternalPaymentQueryKeys.byClaim(claimID),
    queryFn: () => getClaimExternalPaymentLinks(claimID),
    enabled: Boolean(claimID),
    retry: false,
  });
